module.exports = __webpack_public_path__ + "static/media/154.32b60c22.jpg";